import React from 'react';
import { useProfileEdit } from './useProfileEdit';
import { ProfileEditView } from './ProfileEditView';
import MetaTags from '../../../components/MetaTags';

export const ProfileEdit: React.FC = () => {
    const { metaTags, ...viewProps } = useProfileEdit();
    return (
        <React.Fragment>
            <MetaTags {...metaTags} />
            <ProfileEditView {...viewProps} />
        </React.Fragment>
    );
};
